import {
  DELETE_LEAGUE_LOADING,
  DELETE_LEAGUE_ERROR,
  DELETE_LEAGUE_SUCCESS,
  CLEAR_DELETE_LEAGUE,
} from "../../../constant/actionTypes";

const deleteLeagueReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_LEAGUE_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case DELETE_LEAGUE_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case DELETE_LEAGUE_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case CLEAR_DELETE_LEAGUE: {
      let obj = {};
      return obj;
    }
    default:
      return state;
  }
};

export default deleteLeagueReducer;
